import React from 'react';
import { makeStyles } from '@material-ui/styles';
import styles from './Marker.styles';
import RoomIcon from '@material-ui/icons/Room';
import InfoWindow from './InfoWindow';

const useStyles = makeStyles(theme => styles(theme));

export default function Marker({ showInfoWindow, location, setInfoWindowOpenIndex }) {
  const classes = useStyles();

  return <>
    <div className={classes.Marker}>
      <RoomIcon fontSize="large" />
    </div>
    {showInfoWindow && <InfoWindow location={location} setInfoWindowOpenIndex={setInfoWindowOpenIndex} />}
  </>;
}
